import { action } from 'mobx'
import axios from "axios/index";
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import {Common as util} from "../utils/common";
import gql from "../utils/gql";
import history from "../utils/history";


export class AOA {

    @action dmUplad = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'dmUplad',
            variables: data,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 리뷰 부스터 애드온 — 런칭 시 기존 유료자 일괄 부여 (슈퍼어드민 전용, 1회·멱등)
    @action grantReviewWriteAddonGrandfather = (data, cb) => {
        let property = ['cutoffDate'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'grantReviewWriteAddonGrandfather',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') cb(res.data.data[params.operation], res.data.errors);
                    else return res.data.data[params.operation];
                }
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action setShopReviewWriteAddon = (data, cb) => {
        let property = ['store_id', 'shopNo', 'isActive'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'setShopReviewWriteAddon',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') cb(res.data.data[params.operation], res.data.errors);
                    else return res.data.data[params.operation];
                }
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action getShopList = (data, cb) => {

        let property = ['page', 'limit', 'sort', 'searchParams']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getShopList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };




    // === 샵 마일리지 복구 도구 (SuperAdmin 전용) ===
    // store_id 목록을 받아 각 스토어의 mileageConfig 존재 여부 + userMileageHistory 통계를 조회
    @action getShopMileageStatus = (data, cb) => {
        let property = ['store_ids'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getShopMileageStatus',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                const result = res.data && res.data.data ? res.data.data[params.operation] : null;
                const errors = res.data && res.data.errors ? res.data.errors : null;
                const payload = result && result.data ? result.data : null;
                if (typeof cb === 'function') cb(payload, errors);
                else return payload;
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null, [{ message: error.message }]);
                return error;
            });
    };

    // 특정 스토어의 userMileageHistory 리스트 + mileageConfig 추론용 집계 조회
    @action getUserMileageHistoryByStore = (data, cb) => {
        let property = ['store_id', 'page', 'limit'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getUserMileageHistoryByStore',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                const result = res.data && res.data.data ? res.data.data[params.operation] : null;
                const errors = res.data && res.data.errors ? res.data.errors : null;
                const payload = result && result.data ? result.data : null;
                if (typeof cb === 'function') cb(payload, errors);
                else return payload;
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null, [{ message: error.message }]);
                return error;
            });
    };

    // store_id 없이 잘못 생성된 mileageConfig(고아 문서) 조회
    @action getOrphanMileageConfigs = (cb) => {
        let params = {
            type: 'query',
            operation: 'getOrphanMileageConfigs',
            variables: {},
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                const result = res.data && res.data.data ? res.data.data[params.operation] : null;
                const errors = res.data && res.data.errors ? res.data.errors : null;
                const payload = result && result.data ? result.data : null;
                if (typeof cb === 'function') cb(payload, errors);
                else return payload;
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null, [{ message: error.message }]);
                return error;
            });
    };

    // 고아 mileageConfig 개별 삭제 (store_id:null 만 삭제됨)
    @action deleteOrphanMileageConfig = (data, cb) => {
        let property = ['id'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'deleteOrphanMileageConfig',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                const result = res.data && res.data.data ? res.data.data[params.operation] : null;
                const errors = res.data && res.data.errors ? res.data.errors : null;
                const payload = result && result.data ? result.data : null;
                if (typeof cb === 'function') cb(payload, errors);
                else return payload;
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null, [{ message: error.message }]);
                return error;
            });
    };

    // 고아 mileageConfig 일괄 삭제
    @action deleteOrphanMileageConfigs = (cb) => {
        let params = {
            type: 'mutation',
            operation: 'deleteOrphanMileageConfigs',
            variables: {},
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                const result = res.data && res.data.data ? res.data.data[params.operation] : null;
                const errors = res.data && res.data.errors ? res.data.errors : null;
                const payload = result && result.data ? result.data : null;
                if (typeof cb === 'function') cb(payload, errors);
                else return payload;
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null, [{ message: error.message }]);
                return error;
            });
    };

    @action getStoreList = (data, cb) => {

        let property = ['page', 'limit', 'searchParams']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getStoreList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    @action getStoreDetail = (data, cb) => {

        let property = ['store_id', 'shopNo', 'order_id', 'isRefreshToken']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getStoreDetail',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    @action getStoreOrderList = (data, cb) => {

        let property = ['store_id', 'name', 'email', 'page', 'limit', 'sort', 'searchParams', 'isSuper']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getStoreOrderList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    // === 데이터 마이그레이션 전용 (SuperAdmin) — store_id/shopNo 미지정 시 전체 조회 ===
    @action getDataMigrationReviewList = (data, cb) => {
        let property = ['store_id', 'shopNo', 'page', 'limit', 'sort', 'searchParams'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getDataMigrationReviewList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') cb(res.data.data[params.operation]);
                    else return res.data.data[params.operation];
                }
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action getDataMigrationOrderList = (data, cb) => {
        let property = ['store_id', 'page', 'limit', 'sort', 'searchParams'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getDataMigrationOrderList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') cb(res.data.data[params.operation]);
                    else return res.data.data[params.operation];
                }
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action getDataMigrationProductList = (data, cb) => {
        let property = ['store_id', 'shopNo', 'page', 'limit', 'sort', 'searchParams'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getDataMigrationProductList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') cb(res.data.data[params.operation]);
                    else return res.data.data[params.operation];
                }
            })
            .catch(function (error) { console.log(error); return error; });
    };



    @action getNotificationPreview = (data, cb) => {
        let property = ['id', 'shopNo', 'type', 'prevPlan', 'eventTitle', 'eventBody'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'getNotificationPreview', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getNotificationTypeTemplates = (cb) => {
        let params = { type: 'mutation', operation: 'getNotificationTypeTemplates', variables: {}, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action saveNotificationTypeTemplate = (data, cb) => {
        let property = ['type', 'emailSubject', 'emailMessage', 'emailHtml', 'smsMessage'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'saveNotificationTypeTemplate', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getDefaultMailHtml = (data, cb) => {
        let property = ['type'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'getDefaultMailHtml', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action resetNotificationTypeTemplate = (data, cb) => {
        let property = ['type'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'resetNotificationTypeTemplate', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action previewNotificationTypeTemplate = (data, cb) => {
        let property = ['type', 'emailSubject', 'emailMessage', 'emailHtml', 'smsMessage', 'eventTitle', 'eventBody'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'previewNotificationTypeTemplate', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action sendMailTo = (data, cb) => {

        let property = ['id', 'shopNo', 'type', 'prevPlan']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'sendMailTo',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };


    @action getAllStoreList = (data, cb) => {

        let property = ['page', 'limit', 'sort', 'searchParams']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getAllStoreList',
            variables: variables,
            getData: 'docs, totalDocs, totalPages, page, limit, hasPrevPage, hasNextPage'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if(typeof cb === 'function') {
                    cb(result);
                }
                else {
                    return result;
                }
            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    @action getKakaoTemplateInfo = (data, cb) => {
        let property = ['senderKey', 'templateCode'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'query', operation: 'getKakaoTemplateInfo', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => {
            let result = res.data.data[params.operation];
            return result ? result.data : null;
        }).catch(e => e);
    };

    @action getAligoProfileList = (data, cb) => {
        let params = { type: 'query', operation: 'getAligoProfileList', variables: {}, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => {
            let result = res.data.data[params.operation];
            return result ? result.data : null;
        }).catch(e => e);
    };

    @action getNotificationTemplateList = (data, cb) => {
        let property = ['page', 'limit', 'sort', 'searchParams'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'query', operation: 'getNotificationTemplateList', variables, getData: 'docs, totalDocs, totalPages, page, limit, hasPrevPage, hasNextPage' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getNotificationHistoryList = (data, cb) => {
        let property = ['template_id', 'page', 'limit', 'sort'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'query', operation: 'getNotificationHistoryList', variables, getData: 'docs, totalDocs, totalPages, page, limit' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action saveNotificationTemplate = (data, cb) => {
        let property = ['id', 'data'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'saveNotificationTemplate', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action deleteNotificationTemplate = (data, cb) => {
        let property = ['id'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'deleteNotificationTemplate', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action sendNotification = (data, cb) => {
        let property = ['template_id', 'channels', 'isTest'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'sendNotification', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action sendAligoSms = (data, cb) => {
        let property = ['sender', 'receivers', 'message', 'msgType', 'sourceLabel'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'sendAligoSms', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getStoreTelList = (data, cb) => {
        let property = ['filterType', 'shop_id', 'manualStatus', 'limit'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'getStoreTelList', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action saveSmsTemplate = (data, cb) => {
        let property = ['id', 'data'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'saveSmsTemplate', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action deleteSmsTemplate = (data, cb) => {
        let property = ['id'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'deleteSmsTemplate', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getSmsTemplateList = (data, cb) => {
        let property = ['page', 'limit'];
        let variables = util.getDataStByKey(data || {}, property);
        let params = { type: 'query', operation: 'getSmsTemplateList', variables, getData: 'docs, totalDocs, page, totalPages' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action saveScheduledSms = (data, cb) => {
        let property = ['sender', 'receivers', 'message', 'msgType', 'sendAt'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'saveScheduledSms', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action cancelScheduledSms = (data, cb) => {
        let property = ['id'];
        let variables = util.getDataStByKey(data, property);
        let params = { type: 'mutation', operation: 'cancelScheduledSms', variables, getData: 'data' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getScheduledSmsList = (data, cb) => {
        let property = ['status', 'page', 'limit'];
        let variables = util.getDataStByKey(data || {}, property);
        let params = { type: 'query', operation: 'getScheduledSmsList', variables, getData: 'docs, totalDocs, page, totalPages' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getSmsHistoryList = (data, cb) => {
        let property = ['channel', 'topic', 'page', 'limit'];
        let variables = util.getDataStByKey(data || {}, property);
        let params = { type: 'query', operation: 'getNotificationHistoryList', variables, getData: 'docs, totalDocs, page, totalPages' };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams).then(res => res.data.data[params.operation]).catch(e => e);
    };

    @action getAdminMonitorReport = (data, cb) => {

        let params = {
            type: 'query',
            operation: 'getAdminMonitorReport',
            variables: (data && data.forceRefresh) ? { forceRefresh: true } : {},
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if(typeof cb === 'function') {
                    cb(result.data);
                }
                else {
                    return result.data;
                }
            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    // 주문/리뷰 패턴 분석 — 최근 주문/최신 리뷰 리스트 (슈퍼어드민 전용)
    @action getOrderReviewRecentList = (data, cb) => {

        let property = ['store_id', 'shopNo', 'limit', 'fromWrites'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getOrderReviewRecentList',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.status === 200) {
                    const result = res.data.data ? res.data.data[params.operation] : null;
                    const d = result ? result.data : null; // {data: ...} 래퍼 언래핑 후 전달
                    if (typeof cb === 'function') cb(d);
                    else return d;
                }
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null);
                return error;
            });
    };

    // 주문 단건 상세 (items 포함) — 주문/리뷰 패턴 분석 페이지용 (슈퍼어드민 전용)
    @action getOrderDetail = (data, cb) => {

        let property = ['order_id'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getOrderDetail',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.status === 200) {
                    const result = res.data.data ? res.data.data[params.operation] : null;
                    const d = result ? result.data : null;
                    if (typeof cb === 'function') cb(d);
                    else return d;
                }
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null);
                return error;
            });
    };

    // 주문/리뷰 패턴 분석 — 시간대x요일 히트맵 통계 (슈퍼어드민 전용)
    @action getOrderReviewPatternStats = (data, cb) => {

        let property = ['store_id', 'shopNo', 'periodDays', 'fromWrites'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getOrderReviewPatternStats',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.status === 200) {
                    const result = res.data.data ? res.data.data[params.operation] : null;
                    const d = result ? result.data : null; // {data: ...} 래퍼 언래핑 후 전달
                    if (typeof cb === 'function') cb(d);
                    else return d;
                }
            })
            .catch(function (error) {
                console.log(error);
                if (typeof cb === 'function') cb(null);
                return error;
            });
    };

    @action updateStoreMemo = (data, cb) => {

        let property = ['id', 'memo']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'updateStoreMemo',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action getBankTransferOrderList = (data, cb) => {

        let property = ['page', 'limit', 'searchParams'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getBankTransferOrderList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, totalPages, hasNextPage, hasPrevPage, nextPage, prevPage'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {errors: res.data.errors};
                    if (typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation];
                if (typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if (typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action adminChargeStoreMessages = (data, cb) => {

        let property = ['store_id', 'messageType', 'chargeCount', 'chargeAmount', 'chargeCategory', 'memo'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'adminChargeStoreMessages',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if (typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation];
                if (typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if (typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action sendTaxInvoiceRequest = (data, cb) => {

        let property = ['store_id', 'shopNo', 'totalAmount', 'vatAmount', 'supplyAmount', 'useExpiryDate', 'startDate', 'taxInvoiceEmail', 'businessRegNumber', 'bankTransferReason'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'sendTaxInvoiceRequest',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if (typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation];
                if (typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if (typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action setStoreManualUseExpiry = (data, cb) => {

        let property = ['store_id', 'shopNo', 'useExpiryDate', 'startDate', 'totalAmount', 'bankTransferReason', 'taxInvoiceIssued', 'taxInvoiceEmail', 'businessRegNumber'];
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'setStoreManualUseExpiry',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if (typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation];
                if (typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if (typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    @action setStoreSample = (data, cb) => {

        let property = ['store_id', 'isSample']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'setStoreSample',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action updateStoresManualStatus = (data, cb) => {

        let property = ['ids', 'manualStatus']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'updateStoresManualStatus',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action permanentDeleteStore = (data, cb) => {

        let property = ['store_id', 'withdrawal_id', 'confirmName', 'collections']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'permanentDeleteStore',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action getStoreDataCounts = (data, cb) => {

        let property = ['store_id', 'withdrawal_id']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getStoreDataCounts',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    // 데이터 정리 페이지 전용 — isSample/isDelApp 무관 모든 스토어 키워드 검색 (슈퍼어드민)
    @action searchAllStoresForDataCleanup = (data, cb) => {
        let property = ['keyword', 'limit'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'searchAllStoresForDataCleanup',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if (typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation] || {data: null};
                if (typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if (typeof cb === 'function') { cb(error); }
                return error;
            });
    };

    // 슈퍼어드민 전용 — 스토어 컬렉션 데이터 일괄 삭제 (위험)
    @action deleteStoreCollectionData = (data, cb) => {
        let property = ['store_id', 'collections', 'confirmText', 'expectedTotal'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'deleteStoreCollectionData',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                if (res.data && res.data.errors && res.data.errors.length > 0) {
                    const result = {data: null, errors: res.data.errors};
                    if (typeof cb === 'function') { cb(result); } else { return result; }
                    return;
                }
                const result = res.data.data[params.operation] || {data: null};
                if (typeof cb === 'function') { cb(result); } else { return result; }
            })
            .catch(function (error) {
                if (typeof cb === 'function') { cb(error); }
                return error;
            });
    };


    @action renewToken = (data, cb) => {

        let property = ['store_id']
        let variables = util.getDataStByKey(data, property);
        console.log(variables)

        let params = {
            type: 'mutation',
            operation: 'renewToken',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        axios.post('/', gpqParams)
            .then(function (res) {
                history.push('/');

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };


    @action csLogin = (data, cb) => {

        let params = {
            type: 'query',
            operation: 'csLogin',
            variables: data,
            getData: 'emailId permissions token rfToken'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.data.errors) {throw res.data.errors; }
                let resData = res.data.data[params.operation];

                Storage.set('emailId', resData.emailId);
                Storage.set('token', resData.token);
                Storage.set('rfToken', resData.rfToken);

                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }
            })
            .catch(function (error) {
                console.log(error);
                //alert('아이디 또는 비밀번호가 잘못되었습니다.(아이디 또는 비밀번호 확인은 카페24의 앱을 통해 접속 후 확인해 주세요.)');
                //return error;
            });
    };

    @action withdrawal = (data, cb) => {

        let property = ['store_id', 'password', 'reason']
        let variables = util.getDataStByKey(data, property);
        console.log(variables)

        let params = {
            type: 'mutation',
            operation: 'withdrawal',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        axios.post('/', gpqParams)
            .then(function (res) {
            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    @action unsubscribeUser = (data, cb) => {

        let property = ['store_id', 'shopNo']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'unsubscribeUser',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        axios.post('/', gpqParams)
            .then(function (res) {
            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };


    @action initReviewData = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'initReviewData',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action adminCusData = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'adminCusData',
            variables: data,
            getData: 'data'
        };
        const gpqParams = gql(params);

        axios.post('/', gpqParams)
            .then(function (res) {
                if(typeof cb === 'function') {
                    cb(res.data.data[params.operation]);
                }
                else {
                    return res.data.data[params.operation];
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });
    };

    @action getEmailHistoryList = (data, cb) => {

        let property = ['emailType', 'status', 'receiver', 'page', 'limit', 'sort', 'searchParams']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getEmailHistoryList',
            variables: variables,
            getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    @action getAutomaticPayments = (data, cb) => {

        let property = []
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getAutomaticPayments',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    /* ===================== 요금제 플랜 관리 (SuperConfig payment) ===================== */

    @action getSuperConfigPaymentList = (cb) => {
        let params = {
            type: 'query',
            operation: 'getSuperConfigPaymentList',
            variables: {},
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if (typeof cb === 'function') cb(result);
                else return result;
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action getSuperConfigPayment = (data, cb) => {
        let property = ['_id'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getSuperConfigPayment',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if (typeof cb === 'function') cb(result);
                else return result;
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action upsertSuperConfigPayment = (data, cb) => {
        let property = ['_id', 'payTypeFirst', 'payType', 'planPd', 'boosterAddOn', 'isDev', 'version'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'upsertSuperConfigPayment',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if (typeof cb === 'function') cb(result);
                else return result;
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action deleteSuperConfigPayment = (data, cb) => {
        let property = ['_id'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'deleteSuperConfigPayment',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if (typeof cb === 'function') cb(result);
                else return result;
            })
            .catch(function (error) { console.log(error); return error; });
    };

    // === 게시판 메일 템플릿 미리보기 (운영자 — 실제 발송 HTML 확인) ===
    @action getBoardMailPreview = (data, cb) => {
        let property = ['boardName', 'status', 'isNew', 'sampleData'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getBoardMailPreview',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if (typeof cb === 'function') cb(result);
                else return result;
            })
            .catch(function (error) { console.log(error); return error; });
    };

    // === AI 리뷰 키워드 리스트 (운영자 검증) ===
    @action getAiReviewSentenceList = (data, cb) => {
        let property = ['store_id', 'shopNo', 'page', 'limit', 'keyword'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'query',
            operation: 'getAiReviewSentenceList',
            variables: variables,
            // GraphQL List 타입은 docs 가 JSON 이라 자유롭게 필드 노출 — getData 의 docs 만 명시하면 모든 row 필드 반환
            getData: 'docs, totalDocs, totalPages, page, limit'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if (typeof cb === 'function') cb(result);
                else return result;
            })
            .catch(function (error) { console.log(error); return error; });
    };

    @action regenerateAiReviewSentence = (data, cb) => {
        let property = ['store_id', 'shopNo', 'product_ids'];
        let variables = util.getDataStByKey(data, property);
        let params = {
            type: 'mutation',
            operation: 'regenerateAiReviewSentence',
            variables: variables,
            getData: 'data'
        };
        const gpqParams = gql(params);
        return axios.post('/', gpqParams)
            .then(function (res) {
                let result = res.data.data[params.operation];
                if (typeof cb === 'function') cb(result);
                else return result;
            })
            .catch(function (error) { console.log(error); return error; });
    };

}
